import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Auth0Provider } from '@auth0/auth0-react';
import { Toaster } from 'sonner';

import App from './App';
import { SocketProvider } from './lib/socket';
import './index.css';

// TanStack Query client with defaults
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Auth0 configuration
const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || '',
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || '',
  authorizationParams: {
    redirect_uri: `${window.location.origin}/callback`,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE || '',
  },
};

// Validate Auth0 config in development
if (import.meta.env.DEV && (!auth0Config.domain || !auth0Config.clientId)) {
  console.warn(
    'Auth0 configuration missing. Set VITE_AUTH0_DOMAIN and VITE_AUTH0_CLIENT_ID in .env'
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Auth0Provider {...auth0Config}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <SocketProvider>
            <App />
            <Toaster
              position="bottom-right"
              theme="dark"
              toastOptions={{
                style: {
                  background: '#00674a',
                  color: 'white',
                  border: 'none',
                },
                classNames: {
                  toast: '!bg-[#00674a] !text-white !border-none',
                  title: '!text-white !font-semibold',
                  description: '!text-white !opacity-90',
                  actionButton: '!bg-white !text-[#00674a]',
                  cancelButton: '!bg-white/20 !text-white',
                },
              }}
            />
          </SocketProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Auth0Provider>
  </StrictMode>
);
